// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"dc21e49f","404":"82d8dbb4","498":"2d8c7327","787":"cfa6a9a2"}[chunkId] + ".chunk.js";
};